import { PortSequence } from '@/types';

/**
 * Attempts to find a sequence within a list of Port calls from a Line
 * @param portList - list of ports/stops on a line ie. [a,b,c,d,e,f,g,h]
 * @param sequence - list of stops a vessel is doing i.e [c,d,e,f]
 * @returns - array of index where the sequence was found in the ports list ie. [2,3,4,5]
 */
export const calculatePortSequenceIds = (portList: string[], sequence: string[]): number[] | null => {
  const portListLength = portList.length;
  const sequenceLength = sequence.length;

  // Concatenate the array with itself, this is to enable matching on sequences that occur on the loop
  const doubledPorts = [...portList, ...portList];

  // Searches the portList array for a particular subarray
  for (let i = 0; i < portListLength; i += 1) {
    // Takes a slice of the array we're searching and works its way through it, using 'every' to check if all sub items match that sequence
    if (doubledPorts.slice(i, i + sequenceLength).every((val, index) => val === sequence[index])) {
      // If found, it returns the sequential indices of where sub items were found
      return Array.from({ length: sequenceLength }, (_, j) => (i + j) % portListLength);
    }
  }

  return null; // No sequence found
};

export const getPortLineSequence = (portList?: string[], sequence?: string[]): PortSequence[] => {
  if (!portList || !sequence) return [];

  const sequenceIds = calculatePortSequenceIds(portList, sequence) || [];

  if (sequenceIds.length) {
    return sequenceIds.map((position, index) => {
      return {
        position,
        id: sequence[index],
        label: index + 1,
      };
    });
  }

  return sequence.map((id, index) => {
    return {
      id,
      label: index + 1,
    };
  });
};
